import React from 'react'
import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import {
  DcBreadcrumbs,
  DcFlexBox,
  PixelFactoryContext,
  PixelPageContainer,
  PixelTable,
  PixelTag,
  Section,
  SectionContent,
} from 'pixel-base'

import { getContractTypes } from 'utils/api-routes.util'
import { IPixelFactory } from '../../../../../../decl.d'
const breadcrumbs = [
  {
    name: 'Vendors',
    active: false,
  },
  {
    name: 'Manage Contracts',
    active: true,
  },
]

const columns = [
  {
    dataKey: 'term_id',
    name: 'Term Id',
    sortable: true,
    selector: (row) => row.term_id || '--',
  },
  {
    dataKey: 'term_name',
    name: 'Term Name',
    sortable: true,
    selector: (row) =>
      (row.term_name && (
        <PixelTag className="primary">{row.term_name}</PixelTag>
      )) || <PixelTag className="primary">No Contract</PixelTag>,
  },
  {
    dataKey: 'contract_details',
    name: 'Contract Details',
    sortable: true,
    selector: (row) => row.contract_details || '--',
  },
]

const Contracts = () => {
  React.useContext<IPixelFactory>(PixelFactoryContext)
  const [contracts, setContracts] = React.useState<any>([])
  const [tableLoading, setTableLoader] = React.useState(true)
  React.useEffect(() => {
    getAllContracts()
  }, [])

  const getAllContracts = () => {
    setTableLoader(true)
    getContractTypes().subscribe((res) => {
      setContracts(res.response.data)
      setTableLoader(false)
    })
  }
  return (
    <>
      <DcFlexBox
        height="60px"
        fontSize="16px"
        style={{ fontSize: '16px', padding: '8px 0px' }}
      >
        <DcFlexBox
          justifyContent="space-between"
          alignItems="center"
          padding=".5rem 20px"
        >
          <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />

          <ProfileSection />
        </DcFlexBox>
      </DcFlexBox>
      <PixelPageContainer style={{ padding: '0px' }}>
        <Section style={{ padding: '20px' }}>
          <SectionContent>
            <PixelTable
              columns={columns}
              data={contracts}
              progressPending={tableLoading}
            />
          </SectionContent>
        </Section>
      </PixelPageContainer>
    </>
  )
}

export default Contracts
